var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"laid-out-check-boxes"},[_vm._l((_vm.options),function(option,key){return [_c('v-chip',{key:key,attrs:{"label":"","outline":!_vm.isSelected(key),"dark":_vm.isSelected(key),"color":_vm.isSelected(key) ? 'primary' : '#616161'},on:{"click":function($event){_vm.submitData(Number(key))}}},[_vm._v(_vm._s(option))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }